/* ============================================================
   LION & REBEL – FILTERS, SORTING, INFINITE SCROLL (FINAL v3)
   + APPLY / CLEAR BUTTONS (DEFER APPLY)
   ============================================================ */

document.addEventListener("DOMContentLoaded", () => {

  /* -----------------------------------------------------------
     HELPERS
  ----------------------------------------------------------- */

  const debounce = (fn, wait) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(null, args), wait);
    };
  };

  function formToParams(form, params) {
    if (!form || !(form instanceof HTMLFormElement)) return;

    const fd = new FormData(form);
    fd.forEach((value, key) => {
      if (value === "" || value == null) return;
      // Always append so multi-select (sizes, colors, etc.) works
      params.append(key, value);
    });
  }

  function closeDrawer() {
    // NOTE: ID is "FacetDrawer" (capital F) in the Liquid
    const drawer = document.getElementById("FacetDrawer");
    if (!drawer) return;

    drawer.classList.remove("sidebar--opened");
    drawer.style.display = "none";
    document.body.classList.remove("noscroll");
  }

  function replaceGridFromDoc(doc) {
    const newGrid = doc.querySelector("#main-collection-product-grid");
    const grid = document.querySelector("#main-collection-product-grid");
    if (!newGrid || !grid) return;

    // Replace grid contents
    grid.innerHTML = newGrid.innerHTML;

    // Carry over paging / infinite scroll attributes
    const nextPage = newGrid.getAttribute("data-next-page") || "";
    const hasMore = newGrid.getAttribute("data-has-more") || "false";
    const paginate = newGrid.getAttribute("data-paginate") || "";

    if (nextPage) {
      grid.setAttribute("data-next-page", nextPage);
    } else {
      grid.removeAttribute("data-next-page");
    }

    grid.setAttribute("data-has-more", hasMore);
    if (paginate) grid.setAttribute("data-paginate", paginate);

    // Re-sync filters with the *current URL*
    syncFormsWithCurrentURL();

    // Let other scripts know the grid changed
    document.dispatchEvent(new Event("LR:GridReplaced"));
  }

  /* -----------------------------------------------------------
     APPLY FILTERING (AJAX)
  ----------------------------------------------------------- */

  const applyFiltering = debounce(() => {
    // Build params fresh from the forms
    const params = new URLSearchParams();

    const desktopForm = document.getElementById("FacetFiltersForm");
    const mobileForm = document.getElementById("FacetFiltersFormMobile");

    formToParams(desktopForm, params);
    formToParams(mobileForm, params);

    // Add sort_by from hidden select
    const sortSelect = document.getElementById("SortBy");
    if (sortSelect && sortSelect.value) {
      params.set("sort_by", sortSelect.value);
    }

    const searchString = params.toString();
    const basePath = window.location.pathname;

    const finalUrl = searchString ? `${basePath}?${searchString}` : basePath;
    const sectionUrl =
      `${basePath}?section_id=main-collection-product-grid` +
      (searchString ? `&${searchString}` : "");

    fetch(sectionUrl)
      .then(res => res.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, "text/html");

        // First update the URL so syncFormsWithCurrentURL reads the right query
        window.history.replaceState({}, "", finalUrl);

        // Then update the grid + re-sync filter UI
        replaceGridFromDoc(doc);
      })
      .catch(() => {
        // Fallback: full redirect if something goes wrong
        window.location.href = finalUrl;
      });
  }, 300);

  /* -----------------------------------------------------------
     SORT BY (CUSTOM + NATIVE SELECTS)
  ----------------------------------------------------------- */

  const sortTrigger = document.querySelector(".sortby-trigger");
  const sortBox = document.getElementById("SortByOptions");
  const sortSelects = document.querySelectorAll("#SortBy");

  if (sortTrigger && sortBox && sortSelects.length > 0) {

    sortTrigger.addEventListener("click", () => {
      sortBox.classList.toggle("active");
    });

    document.querySelectorAll(".sortby-options .option").forEach(option => {
      option.addEventListener("click", () => {
        const selectedValue = option.dataset.value;

        sortSelects.forEach(select => {
          select.value = selectedValue;
        });

        sortBox.classList.remove("active");

        // Sorting should apply immediately
        applyFiltering();
      });
    });

    sortSelects.forEach(select => {
      select.addEventListener("change", () => applyFiltering());
    });
  }

  /* -----------------------------------------------------------
     MOBILE FILTER DRAWER
  ----------------------------------------------------------- */

  // NOTE: ID is "FacetDrawer" (capital F) in the Liquid
  const drawer = document.getElementById("FacetDrawer");

  if (drawer) {
    const openButtons = document.querySelectorAll(".js-open-facets");
    const closeButtons = document.querySelectorAll(".js-close-facets");

    openButtons.forEach(btn => {
      btn.addEventListener("click", () => {
        drawer.classList.add("sidebar--opened");
        drawer.style.display = "block";
        document.body.classList.add("noscroll");
      });
    });

    closeButtons.forEach(btn => {
      btn.addEventListener("click", () => closeDrawer());
    });
  }

  /* -----------------------------------------------------------
     CLICK-OUTSIDE-TO-CLOSE DRAWER
  ----------------------------------------------------------- */

  document.addEventListener("click", event => {
    if (!drawer) return;

    const isOpen = drawer.classList.contains("sidebar--opened");
    if (!isOpen) return;

    const clickedInside = event.target.closest("#FacetDrawer");
    const clickedOpenButton = event.target.closest(".js-open-facets");

    if (!clickedInside && !clickedOpenButton) {
      closeDrawer();
    }
  });

  /* -----------------------------------------------------------
     FILTER INPUT EVENTS (INSTANT PILL STATE ONLY)
     ✅ NO AUTO APPLY ANYMORE — Apply button does it
  ----------------------------------------------------------- */

  const filterInputs = document.querySelectorAll(
    "#FacetFiltersForm input, #FacetFiltersForm select, #FacetFiltersFormMobile input, #FacetFiltersFormMobile select"
  );

  filterInputs.forEach(input => {
    const eventName =
      (input.type === "checkbox" || input.type === "radio" || input.tagName === "SELECT")
        ? "change"
        : "input";

    input.addEventListener(eventName, () => {
      // Instant visual feedback for pills (no page reload needed)
      if (input.type === "checkbox") {
        const pill = input.closest(".facet-pill");
        if (pill) {
          pill.classList.toggle("facet-pill--active", input.checked);
        }
      }

      // ❌ Removed: applyFiltering();
      // Apply will happen ONLY when user clicks "Apply"
    });
  });

  /* -----------------------------------------------------------
     APPLY + CLEAR BUTTONS (DRAWER FOOTER)
     - Add buttons in Liquid with:
       .js-facets-apply / .js-facets-clear
  ----------------------------------------------------------- */

  function clearAllFilters() {
    const desktopForm = document.getElementById("FacetFiltersForm");
    const mobileForm = document.getElementById("FacetFiltersFormMobile");

    if (desktopForm) desktopForm.reset();
    if (mobileForm) mobileForm.reset();

    // Clear pill active states immediately
    document.querySelectorAll(".facet-pill--active").forEach(p => p.classList.remove("facet-pill--active"));

    // Also reset sort selection if you want (optional)
    // const sortSelect = document.getElementById("SortBy");
    // if (sortSelect) sortSelect.value = sortSelect.querySelector("option")?.value || "";

    applyFiltering();
  }

  function applyFromButtons() {
    applyFiltering();
  }

  document.addEventListener("click", (event) => {
    const applyBtn = event.target.closest(".js-facets-apply");
    const clearBtn = event.target.closest(".js-facets-clear");

    if (applyBtn) {
      event.preventDefault();
      applyFromButtons();
      closeDrawer();
      return;
    }

    if (clearBtn) {
      event.preventDefault();
      clearAllFilters();
      closeDrawer();
      return;
    }
  });

  /* -----------------------------------------------------------
     REMOVE FACET PILL LINKS
  ----------------------------------------------------------- */

  document.addEventListener("click", event => {
    const link = event.target.closest(".js-facet-remove");
    if (!link) return;

    event.preventDefault();

    const url = new URL(link.href);
    const params = new URLSearchParams(url.search);
    const basePath = window.location.pathname;

    const searchString = params.toString();
    const finalUrl = searchString ? `${basePath}?${searchString}` : basePath;

    const sectionUrl =
      `${basePath}?section_id=main-collection-product-grid` +
      (searchString ? `&${searchString}` : "");

    fetch(sectionUrl)
      .then(res => res.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, "text/html");

        // Update URL first, then grid
        window.history.replaceState({}, "", finalUrl);
        replaceGridFromDoc(doc);
      })
      .catch(() => {
        window.location.href = finalUrl;
      });
  });

  /* -----------------------------------------------------------
     SYNC FORMS WITH URL (on load + after grid replace)
  ----------------------------------------------------------- */

  function syncFormsWithCurrentURL() {
    const params = new URLSearchParams(window.location.search);
    const desktopForm = document.getElementById("FacetFiltersForm");
    const mobileForm = document.getElementById("FacetFiltersFormMobile");

    [desktopForm, mobileForm].forEach(form => {
      if (!form) return;

      form.reset();

      form.querySelectorAll("input[name], select[name]").forEach(el => {
        const key = el.name;
        if (!key) return;

        const values = params.getAll(key);
        if (!values.length) {
          if (el.type === "checkbox" || el.type === "radio") {
            el.checked = false;
            const pill = el.closest(".facet-pill");
            if (pill) pill.classList.remove("facet-pill--active");
          }
          return;
        }

        if (el.type === "checkbox" || el.type === "radio") {
          el.checked = values.includes(el.value);
          const pill = el.closest(".facet-pill");
          if (pill) {
            pill.classList.toggle("facet-pill--active", el.checked);
          }
        } else {
          el.value = values.at(-1);
        }
      });
    });

    // Also keep SortBy in sync with URL if needed
    const sortSelect = document.getElementById("SortBy");
    if (sortSelect) {
      const sortBy = params.get("sort_by");
      if (sortBy) sortSelect.value = sortBy;
    }
  }

  syncFormsWithCurrentURL();

  /* ============================================================
     INFINITE SCROLL
  ============================================================ */

  let scrollContainer;
  let loader;
  let isLoading = false;

  function initInfiniteScroll() {
    scrollContainer = document.querySelector("[data-infinite-scroll-container]");
    loader = document.querySelector("#infinite-scroll-loader");
    hideLoaderIfNoMore();
  }

  function hideLoaderIfNoMore() {
    if (!scrollContainer || !loader) return;

    const hasMore = scrollContainer.getAttribute("data-has-more") === "true";
    if (!hasMore) {
      loader.style.display = "none";
    }
  }

  function loadNextPage() {
    if (!scrollContainer || !loader) return;

    const hasMore = scrollContainer.getAttribute("data-has-more") === "true";
    const nextPage = scrollContainer.getAttribute("data-next-page");

    if (!hasMore || !nextPage || isLoading) return;

    isLoading = true;
    loader.style.display = "flex";

    const url = new URL(nextPage, window.location.origin);
    url.searchParams.set("section_id", "main-collection-product-grid");

    const requestedPage = url.searchParams.get("page") || "1";

    fetch(url)
      .then(res => res.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, "text/html");
        const newGrid = doc.querySelector("#main-collection-product-grid");
        if (!newGrid) return;

        const newItems = newGrid.querySelectorAll(
          `.product-item-wrapper[data-page="${requestedPage}"]`
        );

        newItems.forEach(wrapper => {
          scrollContainer.insertBefore(wrapper, loader);
        });

        const newNext = newGrid.getAttribute("data-next-page") || "";
        const newHasMore = newGrid.getAttribute("data-has-more") || "false";

        if (newNext) {
          scrollContainer.setAttribute("data-next-page", newNext);
        } else {
          scrollContainer.removeAttribute("data-next-page");
        }

        scrollContainer.setAttribute("data-has-more", newHasMore);
        hideLoaderIfNoMore();
      })
      .finally(() => {
        loader.style.display = "none";
        isLoading = false;
      });
  }

  function handleScroll() {
    if (!loader) return;

    const rect = loader.getBoundingClientRect();
    if (rect.top < window.innerHeight + 200) {
      loadNextPage();
    }
  }

  initInfiniteScroll();
  window.addEventListener("scroll", handleScroll);

  document.addEventListener("LR:GridReplaced", () => {
    initInfiniteScroll();
  });

});


/* -----------------------------------------------------------
   CLOSE SORT DROPDOWN WHEN CLICKING OUTSIDE
----------------------------------------------------------- */
document.addEventListener("click", event => {
  const isSort = event.target.closest(".sortby-options, .sortby-trigger");
  if (!isSort) {
    const sortBox = document.getElementById("SortByOptions");
    if (sortBox) sortBox.classList.remove("active");
  }
});
